import { makeAutoObservable } from 'mobx'

export class StandStore {
  private _header: number = 0
  private _large?: number
  private _scroll: number = 0

  constructor() {
    makeAutoObservable(this)
  }

  set header(value: number) {
    this._header = value
  }

  set large(value: number | undefined) {
    this._large = value
  }

  set scroll(value: number) {
    this._scroll = value
  }

  get scroll(): number {
    return this._scroll
  }

  get header(): number {
    return this._header
  }

  get top(): number {
    return this._large ?? this._header
  }

  get compact(): boolean {
    return this._scroll > 100
  }
}

export const stand = new StandStore()
